import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AccountService } from '../account.service';
import { RolesUserService } from '../roles-user.service';
import { OrderService } from '../../pedidos/pedidos.service';
import { EventLogService } from 'src/app/shared/logging/event-log.service';
import { SessionIdService } from 'src/core/logging/session-id.service';
import { ExecutionContextService } from 'src/core/context/execution-context.service';
import { ProfileNavigationService } from 'src/core/navigation/profile-navigation.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService  {
  constructor(
    public authService: AccountService,
    public router: Router,
    private serviceRoles: RolesUserService,
    private orderService: OrderService,
    private eventLog: EventLogService,
    private sessionIdService: SessionIdService,
    private executionContext: ExecutionContextService,
    private profileNavigation: ProfileNavigationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.authService.isVigenteKey()) {
      this.eventLog.log('auth', 'token_expirado', {});
      this.sessionIdService.clearSessionId();
      this.authService.logout();
      return false;
    }

    if (this.authService.userValue !== null) {
      this.orderService.setValues(this.authService.userValue.KEY);
      const context = this.executionContext.getAuthenticated();
      if (!context) {
        this.authService.logout();
        return false;
      }

      if (!this.profileNavigation.isAllowedRoute(context, state.url)) {
        this.router.navigate([this.profileNavigation.getDefaultRoute(context)]);
        return false;
      }

      const urlParaValidar = state.url.toString().replace('/', '');
      if (this.serviceRoles.onValidarMenu(urlParaValidar) === false) {
        this.router.navigate(['unauthorized']);
        return false;
      }

      return true;
    } else {
      this.validateAnonimo(state.url, route);
    }
  }

  validateRutaPeril(Ruta: string) {
    return true;
  }

  validateAnonimo(_url: any, _route: any) {
    this.router.navigate(['login']);
    return false;
  }
}
